<template>
  <div class="shadow-xs rounded">
    <div class="shadow-lg rounded bg-white flex flex-col">
      <div class="inline-flex px-4 h-12 items-center">
        <span class="inline-block truncate text-sm">
          {{ link.title || link.url }}
        </span>
      </div>
      <a
        :href="link.url"
        target="_blank"
        class="relative bg-gray-100"
        style="padding-bottom: 66.666667%"
      >
        <img v-if="link.cover" :src="link.cover" class="absolute w-full h-full object-cover" />
        <div v-else class="absolute w-full h-full inline-flex items-center justify-center">
          <div class="flex flex-col items-center space-y-4">
            <svg viewBox="0 0 24 24" fill="currentColor" class="h-12 w-12 text-gray-600">
              <path
                d="M10 6v2H5v11h11v-5h2v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1
                1 0 0 1 1-1h6zm11-3v8h-2V6.413l-7.793
                7.794-1.414-1.414L17.585 5H13V3h8z"
              />
            </svg>
            <p class="text-gray-900">No preview available</p>
          </div>
        </div>
      </a>
      <div v-if="canCopy" class="px-4 py-3">
        <div class="flex flex-col space-y-2">
          <template>
            <BaseButton primary small :disabled="!canCopy || copying" @click="$emit('copy', link)">
              <Loader v-if="copying" small inverse />
              <template v-else>
                <svg
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  class="inline-flex w-5 h-5 mr-2"
                >
                  <path
                    d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6
                    12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                  />
                </svg>
                <span>Copy</span>
              </template>
            </BaseButton>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    link: {
      type: Object,
      required: true,
    },
    canCopy: Boolean,
    copying: Boolean,
  },
};
</script>
